import * as Yup from 'yup';
import moment from 'moment';
import { reportFormModel } from 'src/components/reports/reportFormModel';

export const vehicleWiseFuelConsumptionReportFormModel = {
  formId: 'vehicleWiseFuelConsumptionReportConfig',
  formField: {
    site: reportFormModel.formField.site,
    startTime: reportFormModel.formField.startTime,
    endTime: reportFormModel.formField.endTime
  }
};

const {
  formField: {
    site,
    startTime,
    endTime
  }
} = vehicleWiseFuelConsumptionReportFormModel;

export const vehicleWiseFuelConsumptionReportInitialValues = {
  [site.name]: 'all',
  [startTime.name]: '',
  [endTime.name]: ''
};

export const vehicleWiseFuelConsumptionReportValidationSchema = Yup.object().shape({
  [startTime.name]: Yup.date().nullable().required(startTime.errorMsg),
  [endTime.name]: Yup.date()
    .nullable()
    .required(endTime.errorMsg)
    .min(Yup.ref(startTime.name), 'End date must be later than or equal to start date.')
    .test(
      'vehicle-wise-fuel-consumption-31-day-range',
      'Date range cannot exceed 31 days.',
      function validateDateRange(endDateValue) {
        const startDateValue = this.parent[startTime.name];
        if (!startDateValue || !endDateValue) return true;

        const startDate = moment(startDateValue);
        const endDate = moment(endDateValue);
        if (!startDate.isValid() || !endDate.isValid()) return true;

        return endDate.diff(startDate, 'days') <= 30;
      }
    )
});

export const vehicleWiseFuelConsumptionReportFormConfig = {
  formModel: vehicleWiseFuelConsumptionReportFormModel,
  initialValues: vehicleWiseFuelConsumptionReportInitialValues,
  validation: vehicleWiseFuelConsumptionReportValidationSchema
};
